export default "__VITE_ASSET__BSD8WWHC__"